import { connect } from 'react-redux';
import SelectionModeButton from '../components/SelectionModeButton';
import * as actions from '../actions/map';

const mapStateToProps = state => ({
  singleSelection: state.map.selectionMode === 'single',
});

const mapDispatchToProps = dispatch => ({
  onClick: single => dispatch(
    actions.setSelectionMode(single ? 'multi' : 'single'),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectionModeButton);



// WEBPACK FOOTER //
// ./src/containers/SelectionModeButton.js